import React from 'react';
import Dialog from "@mui/material/Dialog";
import styled from "styled-components";
import {colors} from "../../maps/colors";

const WrapperStyled = styled.div`
  min-width: 300px;
`;

const AccountInfoStyled = styled.div`
  color: ${colors.LIGHT_GRAY};
  padding: 13px;
`;

const AccountImageWrapperStyled = styled.div`
  .profile-image {
    width: 100%;
    height: 200px;
  }

  .no-name-box {
    font-size: 82px;
    color: ${colors.WHITE};
    background-color: #bdbdbd;
    height: 100%;
    text-align: center;
    align-content: center;
    display: grid;
  }

  img {
    height: 200px;
    width: 100%;
    object-fit: cover;
  }
`;

const AccountInfoDialog = ({open, onClose, account, role}) => {

    const name = account.name || "NA";
    const imageUrl = account.imageUrl;
    const getName = () => {
        return `${name.charAt(0)}${name.charAt(name.length - 1)}`;
    };

    return (
        <Dialog
            open={!!open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <WrapperStyled>
                <AccountImageWrapperStyled>
                    <div className="profile-image">
                        {imageUrl && (<img alt={name} src={imageUrl}/>)}

                        {name && !imageUrl && (
                            <div className="no-name-box">{getName()}</div>
                        )}
                    </div>
                </AccountImageWrapperStyled>
                <AccountInfoStyled>
                    <div>
                        {account.name}
                    </div>
                    <div>
                        {account.email}
                    </div>
                    <div>
                        {role}
                    </div>
                </AccountInfoStyled>
            </WrapperStyled>
        </Dialog>
    );
};

export default AccountInfoDialog;